import React from 'react';
import Header from '../Header/Header';
import Footer from './Footer';

const ShippingTerms = () => {
    return (
        <>
            <Header />
            <div className="shipping-container" style={{ padding: '2rem', lineHeight: '1.8', fontFamily: 'Arial, sans-serif', maxWidth: "1200px", margin: "auto" }}>
                <h1>SHIPPING</h1>

                <hp>Shipping Speed and Delivery Charges</hp>
                <p><strong>GloCart</strong> ships its products to almost all parts of India.</p>

                <ul>
                    <p><strong>1. "Shipping charges"</strong> Shipping charge as per weight added in the invoice.</p>
                    <p><strong>2. *Estimated delivery time*</strong> is 3 to 4 days post shipping (business days exclude Sundays and other holidays)</p>
                </ul>

                <p>We aim to provide a delightful customer experience by delivering your products within the estimated delivery time. However, there might be unexpected delays in the delivery of your order due to unavoidable and undetermined logistic challenges beyond our control, for which we are not liable. We would request you to cooperate as we are continuously working towards fulfilling your order on time.</p>

                <p><strong>Note:</strong> Orders placed after 5 p.m. on Fridays will be processed for shipment only on the following Mondays.</p>

                <ul>
                    <p><strong>3.</strong> Below are the <strong>courier partners</strong> we work with:</p>
                </ul>
                <ul>
                    <li>DTDC EExpress</li>
                    <li>Professional Courier</li>
                </ul>

                <p>Once the payment is confirmed and the order is processed, you will receive a tracking id and link to check the status of your Email.</p>

                <ul>
                    <p><strong>4. Payment mode:</strong> You can pay online using payment gateway of <strong>PayTM money</strong>  – Internet banking, Visa, MasterCard, Debit cards, Wallets – PhonePe, Amazon Pay, Freecharge, PayZapp, Airtel Payments Bank, UP ids like – Google Pay, BHIM, Paytm, and more.</p>
                </ul>

                <ul>
                    <p><strong>5. Additional charges:</strong> additional charges applicable by <strong>PayTM money</strong></p>
                </ul>

                <p><em>* The delivery time estimates may vary slightly from state to state. Days are calculated as working days, excluding Saturdays, Sundays, and holidays.</em></p>

               
                <p>You can write to us at <a href="mailto:onlinesales@shreenathfoods.com">onlinesales@shreenathfoods.com</a> for more information.</p>

                <p><strong>Happy Shopping!</strong></p>
            </div>
            <Footer />
        </>
    );
}

export default ShippingTerms;
